/*  中文包  */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu': '网盘',
        'headerlangSelect': '请选择语言',
        'headerLoginOut': '退出登录',

        /*  侧边栏语言设定 */
        'sideMenuFileName': '我的文件',
        'sideMenuPhoto': '图片',
        'sideMunsDoc': '文档',
        'sideMenuVideo': '视频',
        'sideMenuSeed': '种子',
        'sideMenuMusic': '音乐',
        'sideMenuOrther': '其他',
        'sideMenuShareName': '我的分享',
        'sideMenuCollectName': '回收站',
        'sideUsedSpace': '已用空间',
        'sideDownloadSpace': '下载空间',
        'sideMonthlyDownloadNotice': '提示：文件下载大小占用下载空间，超过后将限制下载。',

        /*  用户语言设定 */
        'mainUpload': '文件上传',
        'mainBuildDir': '新建文件夹',
        'mainDownloadOutline': '离线下载',
        'mainSearch': '搜索您的文件',
        'mainAllFile': '全部文件',
        'mainFile': '文件',
        'mainSize': '大小',
        'mainDate': '日期',
        'mainFileDel': '删除',
        'mainConfirmDel': '文件删除后将放入回收站，确认继续？',
        'sure': '确定',
        'cancel': '取消',
        'mainReturn': '返回上一级',
        'mainPagePrev': '上一页',
        'mainPageNext': '下一页',
        'mainLoaded': '已全部加载',
        'mainTotal': '共',
        'mainUnit': '个',
        'dilatation': '扩容',

        /*  回收站设定  */
        'mainHeaderTitle': '提示：回收站不占用网盘空间。',
        'mainHeaderButton': '清空回收站',
        'collectName': '回收站',
        'mainRevertIts': '还原',
        'mianDelData': '删除时间',

        'confirmClear': '确认清除已选中文件吗？（清除后将无法恢复）',
        'confirmClearAll': '确认清空回收站吗？',

        /*  Message设定 */
        'messageBoxTitle': '提示',
        'messageBoxConfirmRevert': '确认还原选中的文件?',
        'loading': '加载中...',
        'loaded': '暂无数据',

        'messageMoveTo': '移动至',
        'filterNotice': '输入关键字进行过滤',
        'messageLoaded': '已下载：',
        'messageMovetion': '文件移动',

        'messageMissKeyWord': '请输入搜索关键词',
        'messageFolderLayersLimit': '创建失败 文件夹层级深度不超过5级',
        'messageSameFolderName': '创建失败 存在相同文件名称',
        'messageEmptyFolderName': '请输入文件夹名称',
        'messageMoveSame': '无法移动至相同文件夹',
        'messageActionError': '操作失败',
        'messageActionSuccess': '操作成功',
        'messageServerIsBusy': '服务器繁忙',
        'messageUploadOverLimit': '选取文件数量过多（5个以内）',
        'messageDiskFreeFull': '用户空间不足',
        'messageUploadTypeError': '无法上传此类型文件',
        'messageUploadMaxSize': '上传文件过大（5M以内）',
        'messageUploadSuccess': '上传成功',
        'messageUploadFailed': '上传失败',
        'messageDownloadFailed': '下载失败',
        'messageMonthFlowLimit': '当月上传/下载流量超过限制，本次操作限制64KB以内',
        'messageDownloadMax': '下载文件过大（5M以内）',

        'systemRequestError': '请求失败',
        'fileSizeError': '文件过大',
        'fileFlowIn64': '本月下载/上传限制64KB以内',
        'systemDownloadOverFlow': '本月下载空间已满',

        'fileDownload': '下载',
        'fileDelete': '删除',
        'fileRemove': '移动',
        'fileShare': '分享',
        'fileClear': '清空',
        'fileReplace': '替换'

    },
    ...zhLocale
}

export default cn



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js